import { render, staticRenderFns } from "./TicketCardDetail.vue?vue&type=template&id=901790f8&"
import script from "./TicketCardDetail.vue?vue&type=script&lang=js&"
export * from "./TicketCardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports